import React from "react";
import "../assets/css/component/SearchBar.css";

/**
 * SearchBar는 "검색 조건의 단일 컨트롤 타워"
 * - 검색 범위 (recent / my / interest)
 * - 카테고리
 * - 키워드
 */
export type SearchBarProps = {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

	onSubmit: (params: {
		keyword: string;
		type: "my" | "recent" | "interest";
		category: string | null;
	}) => void;

	type: "my" | "recent" | "interest";
	onTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;

	/** 🔽 전부 optional 처리 */
	category?: string | null;
	categoryList?: string[];
	onCategoryChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;

	placeholder?: string;
};

const SearchBar: React.FC<SearchBarProps> = ({
												 value,
												 onChange,
												 onSubmit,
												 placeholder,
												 type,
												 onTypeChange,
												 category,
												 categoryList,
												 onCategoryChange,
											 }) => {

	const handleSubmit = () => {
		onSubmit({
			keyword: value,
			type,
			category: category ?? null,
		});
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			handleSubmit();
		}
	};

	return (
		<div className="searchbar-wrapper">
			{/* 🔹 검색 범위 선택 */}
			<select
				className="searchbar-select"
				value={type}
				onChange={onTypeChange}
			>
				<option value="recent">최신 Fact</option>
				<option value="my">나의 Fact</option>
				<option value="interest">관심 Fact</option>
			</select>

			{/* 🔹 카테고리 선택 */}
			{categoryList && onCategoryChange && (
				<select
					className="searchbar-select"
					value={category ?? ""}
					onChange={onCategoryChange}
				>
					<option value="">전체 카테고리</option>
					{categoryList.map((cat) => (
						<option key={cat} value={cat}>
							{cat}
						</option>
					))}
				</select>
			)}

			{/* 🔹 검색어 입력 */}
			<input
				className="searchbar-input"
				type="search"
				autoComplete="off"
				spellCheck="false"
				placeholder={placeholder || "Fact 검색"}
				value={value}
				onChange={onChange}
				onKeyDown={handleKeyDown}
			/>

			<button className="searchbar-btn" onClick={handleSubmit}>
				검색
			</button>
		</div>
	);
};

export default SearchBar;
